export class OrderItemTemplate {
  id: number;
  productID: number;
  price: number;
  qty: number;
  qtyUnit: string;
  perQty: number;
  unitDiff: number;
  discount: number;
  orderText: string;
  surchargeLimit1: number;
  surchargeValue1: number;
  surchargeLimit2: number;
  surchargeValue2: number;
  surchargeLimit3: number;
  orderItemNumber: string;
  tankNr: number;
  saleLineNumber: number;
  abgabeTyp: string;
  taxID: string;
  extNr1: string;
  extNr2: string;
  printInfo: string;
  productName: string;

  static fromOrderItem(orderItem) {
    let orderItemTemplate = new OrderItemTemplate();
    Object.assign(orderItemTemplate, {
      id: 0,
      productID: orderItem.productID,
      price: orderItem.price,
      qty: orderItem.qty,
      qtyUnit: orderItem.qtyUnit,
      perQty: orderItem.perQty,
      unitDiff: orderItem.unitDiff,
      discount: orderItem.discount,
      orderText: orderItem.orderText,
      surchargeLimit1: orderItem.surchargeLimit1,
      surchargeValue1: orderItem.surchargeValue1,
      surchargeLimit2: orderItem.surchargeLimit2,
      surchargeValue2: orderItem.surchargeValue2,
      surchargeLimit3: orderItem.surchargeLimit3,
      orderItemNumber: orderItem.orderItemNumber,
      tankNr: orderItem.tankNr,
      saleLineNumber: orderItem.saleLineNumber,
      abgabeTyp: orderItem.abgabeTyp,
      taxID: orderItem.taxID,
      extNr1: orderItem.extNr1,
      extNr2: orderItem.extNr2,
      printInfo: orderItem.printInfo,
      productName: orderItem.productName,
      product: { ...orderItem.product }
    });
    return orderItemTemplate;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/order-item-template.ts